'use client'

import { useParams } from 'next/navigation'

import { useLocaleContext } from '~/i18n/locale-provider'
import { defaultLocale, type Locale } from '~/i18n/routing'

export const useLocale = (): Locale => {
	const params = useParams<{ locale?: string }>()
	const { locale } = useLocaleContext()

	return (params?.locale as Locale | undefined) ?? locale ?? defaultLocale
}
